import React, { useContext, useEffect, useState } from "react";
import { Link, Redirect } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import { Dropdown, notification, Menu, Icon, Modal, Table } from "antd";

import { useFiltros } from "../FiltrosContext";
import { GlobalContext } from "../../../../app/providers/GlobalState";

import TabelaTurmas from "./TabelaTurmas";

const confirm = Modal.confirm;
const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

const Tabelas = () => {
    const [organismo, setOrganismo] = useState(undefined);
    const [turmas, setTurmas] = useState([]);
    const [turmasMobile, setTurmasMobile] = useState([]);
    const [pagination, setPagination] = useState({
        pageSize: 10,
        current: 1,
        total: 0
    });
    const [loading, setLoading] = useState(false);
    const [redirectLink, setRedirectLink] = useState("");
    const [redirect, setRedirect] = useState(false);

    const { pesquisa, edicao, categoria, ativo, setTurmaId, setDisciplinaId, setDrawerVisivel, setDrawerDisciplinaVisivel, refreshKey } =
        useFiltros();

    const globalContext = useContext(GlobalContext);

    const acesso = globalContext.acessos?.find(x => x.func === 1);
    const acessoM = globalContext.acessos?.find(x => x.func === 13);
    const acessoMultisseriado = globalContext.acessos?.find(x => x.func === 27);

    const handleChangeTable = (pagination, filters, sorter) => {
        var _pagination = this.state.pagination;
        _pagination.current = pagination.current;

        this.setState(
            {
                pagination: _pagination
            },
            () => {
                carregarTurmas();
            }
        );
    };

    const carregarTurmas = () => {
        setLoading(true);

        axios({
            method: "get",
            url: "/api/gestao-turmas/listar-turmas-ensino-especial",
            params: {
                pesquisa: pesquisa,
                pageSize: pagination.pageSize,
                page: pagination.current,
                filtroEdicao: edicao,
                filtroCategoria: categoria,
                filtroOrganismo: organismo,
                ativo: ativo
            }
        })
            .then(response => {
                let _turmas = [];
                let _turmaMobile = [];
                const { turmas, total } = response.data;

                turmas.map(turma => {
                    // Propriedades comuns
                    const propriedadesComuns = {
                        key: turma.id,
                        id: turma.id,
                        codigo: turma.codigo,
                        nome: turma.nome,
                        dt_inicio: turma.dt_inicio,
                        dt_fim: turma.dt_fim,
                        coordenadores: turma.coordenadores,
                        multisseriado: turma.multisseriado,
                        subcursos: []
                    };

                    _turmas.push({
                        ...propriedadesComuns,
                        edicao: turma.edicao,
                        turma: (
                            <div className="nome-colaborador" style={{ marginLeft: 0 }}>
                                <span className="titulo-curso">
                                    {turma.codigo} - {turma.nome}
                                </span>
                                {(turma.multisseriado != null || turma.fechado) && (
                                    <div style={{ display: "flex", gap: 5 }}>
                                        {turma.multisseriado != null && (
                                            <span className="tag-multisseriado" title="Multisseriado">
                                                {turma.multisseriado?.nome}
                                            </span>
                                        )}
                                        {turma.fechado && <span className="tag-fechado">Fechado</span>}
                                    </div>
                                )}
                            </div>
                        ),
                        categoria: turma.categoria,
                        periodo: turma.periodo_letivo ? JSON.parse(turma.periodo_letivo).join(", ") : "",
                        dt_disponivel: turma.dt_disponivel,
                        inscritos: turma.inscritos,
                        grupo: turma.grupo,
                        opcoes: montarMenuTurma(turma)
                    });

                    _turmaMobile.push({
                        ...propriedadesComuns,
                        turma: (
                            <div className="nome-colaborador" style={{ marginLeft: 0 }}>
                                <span className="titulo-curso">
                                    {turma.codigo} - {turma.nome}
                                </span>
                                {turma.multisseriado != "" ||
                                    (turma.fechado && (
                                        <div style={{ display: "flex", gap: 5 }}>
                                            {turma.multisseriado != "" && (
                                                <span className="tag-multisseriado" title="Multisseriado">
                                                    {turma.multisseriado}
                                                </span>
                                            )}
                                            {turma.fechado && <span className="tag-fechado">Fechado</span>}
                                        </div>
                                    ))}
                            </div>
                        ),
                        periodo: (
                            <div>
                                <span>
                                    {turma.dt_fim
                                        ? `${moment(turma.dt_inicio).format("DD/MM/YYYY")} - ${moment(turma.dt_fim).format("DD/MM/YYYY")}`
                                        : moment(turma.dt_inicio).format("DD/MM/YYYY")}
                                </span>
                                {turma.fechado ? (
                                    <div className="tag-fechado">
                                        Fechado (
                                        {turma.dt_fechado && (
                                            <span style={{ fontSize: "12px" }}>{moment(turma.dt_fechado).format("DD/MM/YYYY")})</span>
                                        )}
                                    </div>
                                ) : (
                                    ""
                                )}
                            </div>
                        ),
                        opcoes: (acesso?.create || acesso?.update || acesso?.delete || acessoM) && (
                            <Dropdown
                                overlay={montarMenuTurmaMobile(turma)}
                                placement="bottomLeft"
                                onClick={event => event.stopPropagation()}
                                overlayStyle={{
                                    zIndex: "9"
                                }}
                                trigger={["click"]}
                            >
                                <Link to="#" className="botao-icon-configs">
                                    <i className="fas fa-cog" />
                                </Link>
                            </Dropdown>
                        )
                    });
                });

                setTurmas(_turmas);
                setTurmasMobile(_turmaMobile);
                setPagination({ ...pagination, total: total });
                setLoading(false);
            })
            .catch(error => {
                if (error?.response?.status === 401) {
                    setRedirectLink("/login");
                    setRedirect(true);
                } else {
                    openNotificationWithIcon("error", "Erro", "Não foi possível carregar as turmas");
                    setLoading(false);
                }
            });
    };

    const ativarTurmas = turmaId => {
        confirm({
            title: ativo ? "Pretende inativar esta turma?" : "Pretende ativar esta turma?",
            okText: "Confirmar",
            okType: "Cancelar",
            onOk: () => {
                axios({
                    method: "put",
                    url: "/api/gestao-turmas/ativar-curso-disciplinas",
                    params: {
                        cursoid: turmaId
                    }
                })
                    .then(() => {
                        setTurmas(prev => prev.filter(x => x.id !== turmaId));
                        setTurmasMobile(prev => prev.filter(x => x.id !== turmaId));
                        setPagination(prev => ({ ...prev, total: prev.total - 1 }));

                        openNotificationWithIcon("success", "Sucesso", ativo ? "Turma inativada!" : "Turma ativada!");
                    })
                    .catch(error => {
                        openNotificationWithIcon(
                            "error",
                            "Erro",
                            ativo ? "Não foi possível inativar a turma!" : "Não foi possível ativar a turma!"
                        );
                    });
            }
        });
    };

    const excluirTurma = turmaId => {
        confirm({
            title: "Pretende excluir esta turma?",
            okText: "Confirmar",
            okType: "Cancelar",
            onOk: () => {
                axios({
                    method: "delete",
                    url: "/api/gestao-turmas/excluir-curso-disciplina",
                    params: {
                        cursoid: turmaId
                    }
                })
                    .then(() => {
                        setTurmas(prev => prev.filter(x => x.id !== turmaId));
                        setTurmasMobile(prev => prev.filter(x => x.id !== turmaId));
                        setPagination(prev => ({ ...prev, total: prev.total - 1 }));

                        openNotificationWithIcon("success", "Sucesso", "Turma excluida!");
                    })
                    .catch(() => {
                        openNotificationWithIcon("error", "Erro", "Não foi possível excluir a turma");
                    });
            }
        });
    };

    const ativarDisciplina = (id, ativo, cursoIndex) => {
        confirm({
            title: ativo ? "Pretende inativar este acompanhamento?" : "Pretende ativar este acompanhamento?",
            okText: "Confirmar",
            okType: "Cancelar",
            onOk: () => {
                axios({
                    method: "put",
                    url: "/api/gestao-turmas/ativar-curso-disciplinas",
                    params: {
                        cursoId: id
                    }
                })
                    .then(() => {
                        const _turmas = [...turmas];
                        const _subcursos = [..._turmas[cursoIndex].subcursos];

                        const subIndex = _subcursos.findIndex(x => x.id === id);
                        _subcursos[subIndex] = {
                            ..._subcursos[subIndex],
                            ativo: !_subcursos[subIndex].ativo
                        };

                        _turmas[cursoIndex] = {
                            ..._turmas[cursoIndex],
                            subcursos: _subcursos
                        };

                        setTurmas(_turmas);
                        setTurmasMobile(_turmas);
                    })
                    .catch(() => {
                        openNotificationWithIcon(
                            "error",
                            "Erro",
                            ativo ? "Não foi possível inativar a acompanhamento!" : "Não foi possível ativar a acompanhamento!"
                        );
                    });
            }
        });
    };

    const excluirDisciplina = (disciplinaId, cursoIndex) => {
        confirm({
            title: "Pretende excluir este acompanhamento?",
            okText: "Confirmar",
            okType: "Cancelar",
            onOk: () => {
                axios({
                    method: "delete",
                    url: "/api/gestao-turmas/excluir-curso",
                    params: {
                        cursoid: disciplinaId
                    }
                })
                    .then(() => {
                        openNotificationWithIcon("success", "Sucesso", "Acompanhamento excluido!");
                        var _turmas = turmas;
                        _turmas[cursoIndex].subcursos = _turmas[cursoIndex].subcursos.filter(x => x.id !== disciplinaId);

                        setTurmas([..._turmas]);
                    })
                    .catch(() => {
                        openNotificationWithIcon("error", "Erro", "Não foi possível excluir o acompanhamento");
                    });
            }
        });
    };

    const montarMenuTurma = turma => {
        const divStyle = { display: "flex", alignItems: "center", gap: "10px", justifyContent: "flex-end" };

        if (ativo)
            return (
                <div style={divStyle}>
                    {acesso?.create && (
                        <Link
                            to="#"
                            className="botao-icon-adicionar"
                            title="Adicionar Disciplina"
                            onClick={event => {
                                event.stopPropagation();
                                setTurmaId(turma.id);
                                setDrawerDisciplinaVisivel(true);
                            }}
                        >
                            <Icon type="plus" />
                        </Link>
                    )}
                    {acesso?.update && (
                        <Link
                            to="#"
                            className="botao-icon-editar"
                            title="Editar"
                            onClick={event => {
                                event.stopPropagation();
                                setDrawerVisivel(true);
                                setTurmaId(turma.id);
                            }}
                        >
                            <Icon type="edit" />
                        </Link>
                    )}
                    {acesso?.update && (
                        <Link
                            to="#"
                            className="botao-icon-inativar"
                            title="Inativar"
                            onClick={event => {
                                event.stopPropagation();
                                ativarTurmas(turma.id);
                            }}
                        >
                            <Icon type="close" />
                        </Link>
                    )}
                    <Dropdown
                        overlay={montarMenuDropdown(turma)}
                        placement="bottomLeft"
                        onClick={event => event.stopPropagation()}
                        overlayStyle={{
                            zIndex: "9"
                        }}
                    >
                        <Link to="#" className="botao-icon-configs">
                            <i className="fas fa-cog" />
                        </Link>
                    </Dropdown>
                </div>
            );

        return (
            <div style={divStyle}>
                {acesso?.update && (
                    <Link
                        to="#"
                        className="botao-icon-ativar"
                        title="Ativar"
                        onClick={event => {
                            event.stopPropagation();
                            ativarTurmas(turma.id);
                        }}
                    >
                        <Icon type="check" />
                    </Link>
                )}
                {acesso?.delete && (
                    <Link
                        to="#"
                        className="botao-icon-excluir"
                        title="Excluir"
                        onClick={event => {
                            event.stopPropagation();
                            excluirTurma(turma.id);
                        }}
                    >
                        <Icon type="delete" />
                    </Link>
                )}
            </div>
        );
    };

    const montarMenuTurmaMobile = turma => {
        if (ativo) {
            return (
                <Menu>
                    {!turma.grupo && acesso?.create && (
                        <Menu.Item>
                            <Link
                                to="#"
                                onClick={event => {
                                    event.stopPropagation();
                                    setTurmaId(turma.id);
                                    setDrawerDisciplinaVisivel(true);
                                }}
                            >
                                Adicionar Disciplina
                            </Link>
                        </Menu.Item>
                    )}
                    {acesso?.update && (
                        <Menu.Item>
                            <Link
                                to="#"
                                onClick={event => {
                                    event.stopPropagation();
                                    setDrawerVisivel(true);
                                    setTurmaId(turma.id);
                                }}
                            >
                                Editar
                            </Link>
                        </Menu.Item>
                    )}
                    {acesso?.update && (
                        <Menu.Item>
                            <Link
                                to="#"
                                onClick={event => {
                                    event.stopPropagation();
                                    ativarTurmas(turma.id);
                                }}
                            >
                                Inativar
                            </Link>
                        </Menu.Item>
                    )}
                    {acessoM && (
                        <Menu.Item>
                            <Link
                                to={`/${turma.nome.replace(/[&/\\#,+()$~%.'":*?!<>{}\s]/g, "-").toLowerCase()}/gestao-turma-inscricoes`}
                                onClick={() => {
                                    localStorage.setItem("tipo_inscricao", turma.tipo_inscricao);
                                    localStorage.setItem("cod_curso", turma.codigo ? turma.codigo : "");
                                    localStorage.setItem("nome_curso", turma.nome);
                                    localStorage.setItem("codigo_curso", turma.id);
                                    localStorage.setItem("escola_id", turma.organismo);
                                    localStorage.setItem("return_link", "/gestao-ensino-especial");
                                    localStorage.setItem("tipo_turma", "ENSINO_ESPECIAL");
                                    localStorage.removeItem("nome_curso_pai");
                                }}
                            >
                                Matrículas
                            </Link>
                        </Menu.Item>
                    )}
                </Menu>
            );
        } else {
            return (
                <Menu>
                    {acesso?.update && (
                        <Menu.Item>
                            <Link
                                to="#"
                                onClick={event => {
                                    event.stopPropagation();
                                    ativarTurmas(turma.id);
                                }}
                            >
                                Ativar
                            </Link>
                        </Menu.Item>
                    )}
                    {acesso?.delete && (
                        <Menu.Item>
                            <Link
                                to="#"
                                onClick={event => {
                                    event.stopPropagation();
                                    excluirTurma(turma.id);
                                }}
                            >
                                Excluir
                            </Link>
                        </Menu.Item>
                    )}
                </Menu>
            );
        }
    };

    const montarMenuDropdown = turma => {
        const acessoMultisseriado = globalContext.acessos?.find(x => x.func === 27);

        return (
            <Menu>
                {acessoM && (
                    <Menu.Item>
                        <Link
                            to={`/${turma.nome.replace(/[&/\\#,+()$~%.'":*?!<>{}\s]/g, "-").toLowerCase()}/gestao-turma-inscricoes`}
                            onClick={() => {
                                localStorage.setItem("cod_curso", turma.codigo ? turma.codigo : "");
                                localStorage.setItem("nome_curso", turma.nome);
                                localStorage.setItem("codigo_curso", turma.id);
                                localStorage.setItem("escola_id", turma.organismo);
                                localStorage.setItem("return_link", "/gestao-ensino-especial");
                                localStorage.setItem("tipo_turma", "ENSINO_ESPECIAL");
                                localStorage.removeItem("nome_curso_pai");
                            }}
                        >
                            Matrículas
                        </Link>
                    </Menu.Item>
                )}
            </Menu>
        );
    };

    const montarMenuDisciplina = (disciplina, cursoIndex, turma) => {
        const divStyle = { display: "flex", alignItems: "center", gap: "10px", justifyContent: "flex-end" };

        if (disciplina.ativo)
            return (
                <div style={divStyle}>
                    {acesso?.update && (
                        <Link
                            to="#"
                            className="botao-icon-editar"
                            title="Editar"
                            onClick={event => {
                                event.stopPropagation();
                                event.stopPropagation();
                                setDrawerDisciplinaVisivel(true);
                                setTurmaId(turma.id);
                                setDisciplinaId(disciplina.id);
                            }}
                        >
                            <Icon type="edit" />
                        </Link>
                    )}
                    {acesso?.update && (
                        <Link
                            to="#"
                            className="botao-icon-inativar"
                            title="Inativar"
                            onClick={event => {
                                event.stopPropagation();
                                ativarDisciplina(disciplina.id, disciplina.ativo, cursoIndex);
                            }}
                        >
                            <Icon type="close" />
                        </Link>
                    )}
                </div>
            );

        return (
            <div style={divStyle}>
                {acesso?.update && (
                    <Link
                        to="#"
                        className="botao-icon-ativar"
                        title="Ativar"
                        onClick={event => {
                            event.stopPropagation();
                            ativarDisciplina(disciplina.id, disciplina.ativo, cursoIndex);
                        }}
                    >
                        <Icon type="check" />
                    </Link>
                )}
                {acesso?.delete && (
                    <Link
                        to="#"
                        className="botao-icon-excluir"
                        title="Excluir"
                        onClick={event => {
                            event.stopPropagation();
                            excluirDisciplina(disciplina.id, cursoIndex);
                        }}
                    >
                        <Icon type="delete" />
                    </Link>
                )}
            </div>
        );
    };

    const montarMenuDisciplinaMobile = (disciplina, cursoIndex, curso) => {
        const acesso = this.context.acessos?.find(x => x.func === 1);

        if (disciplina.ativo) {
            return (
                <Menu>
                    {acesso?.update && (
                        <Menu.Item>
                            <Link
                                to="#"
                                onClick={event => {
                                    event.stopPropagation();
                                    setDrawerDisciplinaVisivel(true);
                                    setDisciplinaId(disciplina.id);
                                }}
                            >
                                Editar
                            </Link>
                        </Menu.Item>
                    )}
                    {acesso?.update && (
                        <Menu.Item>
                            <Link
                                to="#"
                                onClick={event => {
                                    event.stopPropagation();
                                    ativarDisciplina(disciplina.id, disciplina.ativo, cursoIndex);
                                }}
                            >
                                Inativar
                            </Link>
                        </Menu.Item>
                    )}
                </Menu>
            );
        } else {
            return (
                <Menu>
                    {acesso?.update && (
                        <Menu.Item>
                            <Link
                                to="#"
                                onClick={event => {
                                    event.stopPropagation();
                                    ativarDisciplina(disciplina.id, disciplina.ativo, cursoIndex);
                                }}
                            >
                                Ativar
                            </Link>
                        </Menu.Item>
                    )}
                    {acesso?.delete && (
                        <Menu.Item>
                            <Link
                                to="#"
                                onClick={event => {
                                    event.stopPropagation();
                                    excluirDisciplina(disciplina.id, cursoIndex);
                                }}
                            >
                                Excluir
                            </Link>
                        </Menu.Item>
                    )}
                </Menu>
            );
        }
    };

    const onRowClick = (cursoNome, turmaNome, cursoId, cursoPai, multisseriado) => {
        globalContext.atualizarState({
            lista_modulos: [],
            lista_disciplinas: []
        });
        localStorage.setItem("codigo_curso", cursoId);
        localStorage.setItem(
            "opcao_voltar",
            JSON.stringify({
                pesquisa: pesquisa,
                // calendario: this.state.filtroCalendario,
                // organismo: this.state.filtroOrganismo,
                ativo: ativo,
                link_voltar: "/gestao-ensino-especial",
                link_voltar_curso: "",
                pagination: pagination
            })
        );

        setRedirectLink(
            `/${multisseriado ? "gerir-multisseriado" : "gerir-detalhe-turma"}/${turmaNome
                .replace(/[&/\\#,+()$~%.'":*?!<>{}\s]/g, "-")
                .toLowerCase()}${cursoNome.replace(/[&/\\#,+()$~%.'":*?!<>{}\s]/g, "-").toLowerCase()}/${
                cursoPai ? "atendimentos" : "atendimentos-aluno"
            }`
        );
        setRedirect(true);
    };

    const expandedRowRenderDesktop = (record, index) => {
        const columns = [
            {
                title: "Disciplina",
                dataIndex: "curso",
                render: (text, record) => (!record.ativo ? <div className="inativo">{text}</div> : text)
            },
            {
                title: "At. Criados",
                dataIndex: "aulasCriadas",
                width: 120,
                render: (text, record) => (!record.ativo ? <div className="inativo">{text}</div> : text)
            },
            {
                title: "At. Dados",
                dataIndex: "aulasDadas",
                width: 100,
                render: (text, record) => (!record.ativo ? <div className="inativo">{text}</div> : text)
            },
            {
                title: "Inscritos",
                dataIndex: "inscritos",
                width: 100,
                render: (text, record) => (!record.ativo ? <div className="inativo">{text}</div> : text)
            },
            {
                title: "Coord. / Prof.",
                dataIndex: "professores",
                width: 200,
                render: (text, record) => (!record.ativo ? <div className="inativo">{text}</div> : text)
            },
            {
                title: "",
                dataIndex: "opcoes",
                className: "td-50"
            }
        ];

        return (
            <Table
                id="disciplinas"
                columns={columns}
                dataSource={listarSubCursos(record.subcursos, index, record)}
                loading={{
                    spinning: !record.subcursos,
                    indicator: (
                        <div className="loading-data-table">
                            <div className="loading" />
                        </div>
                    )
                }}
                pagination={false}
                locale={{ emptyText: "Não existem dados!" }}
                rowClassName={acesso?.read ? "clickeble-row" : ""}
                onRow={(record2, index2) => {
                    return {
                        onClick: acesso?.read
                            ? () => onRowClick(record2.nome, record.nome, record2.id, false, record.multisseriado)
                            : () => {}
                    };
                }}
            />
        );
    };

    const expandedRowRenderMobile = (record, index) => {
        const columns = [
            {
                title: "Disciplina",
                dataIndex: "curso",
                className: "td-250",
                render: (text, record) => (!record.ativo ? <div className="inativo">{text}</div> : text)
            },
            {
                title: "",
                dataIndex: "opcoes",
                className: "td-50"
            }
        ];

        return (
            <Table
                id="disciplinas"
                columns={columns}
                dataSource={listarSubCursosMobile(record.subcursos, index, record)}
                loading={{
                    spinning: !record.subcursos.length,
                    indicator: (
                        <div className="loading-data-table">
                            <div className="loading" />
                        </div>
                    )
                }}
                pagination={false}
                locale={{ emptyText: "Não existem dados!" }}
                rowClassName={acesso?.read ? "clickeble-row" : ""}
                onRow={(record2, index2) => {
                    return {
                        onClick: acesso?.read
                            ? () => onRowClick(record2.nome, record.nome, record2.id, false, record.multisseriado)
                            : () => {}
                    };
                }}
            />
        );
    };

    const carregarDisciplinas = (expanded, record) => {
        if (expanded)
            axios({
                method: "get",
                url: "/api/gestao-turmas/listar-disciplinas-ensino-especial",
                params: {
                    turmaId: record.id,
                    perfilId: globalContext.perfil?.id
                }
            })
                .then(response => {
                    var _turmas = turmas;

                    var index = _turmas.findIndex(x => x.id === record.id);

                    _turmas[index].subcursos = response.data;

                    setTurmas([..._turmas]);
                })
                .catch(error => {
                    if (error.response.status === 401) {
                        setRedirectLink("/login");
                        setRedirect(true);
                    }
                });
    };

    const carregarDisciplinasMobile = (expanded, record) => {
        if (expanded)
            axios({
                method: "get",
                url: "/api/gestao-turmas/listar-disciplinas-ensino-especial",
                params: {
                    turmaId: record.id,
                    perfilId: globalContext.perfil?.id
                }
            })
                .then(response => {
                    var _turmas = turmasMobile;

                    var index = _turmas.findIndex(x => x.id === record.id);

                    _turmas[index].subcursos = response.data;

                    setTurmasMobile([..._turmas]);
                })
                .catch(error => {
                    if (error.response.status === 401) {
                        setRedirectLink("/login");
                        setRedirect(true);
                    }
                });
    };

    const listarSubCursos = (subcursos, cursoIndex, curso) => {
        var _subcursos = [];

        subcursos.map(subcurso => {
            _subcursos.push({
                key: subcurso.id,
                id: subcurso.id,
                edicao: (
                    <div>
                        <span>{subcurso.edicao}</span>
                        {subcurso.ano || subcurso.turma ? (
                            <span style={{ display: "block" }}>{`${subcurso.ano ? subcurso.ano : ""} ${
                                subcurso.turma ? subcurso.turma : ""
                            }`}</span>
                        ) : null}
                    </div>
                ),
                curso: (
                    <div className="nome-colaborador">
                        {!subcurso.agrupado ? (
                            <span className="titulo-curso">
                                {subcurso.codigo} - {subcurso.nome}
                            </span>
                        ) : (
                            <span className="titulo-curso">{subcurso.nome}</span>
                        )}
                        {subcurso.fechado && <span className="tag-fechado">Fechado</span>}
                    </div>
                ),
                nome: subcurso.nome,
                periodo: (
                    <div>
                        <span>
                            {subcurso.dt_fim
                                ? `${moment(subcurso.dt_inicio).format("DD/MM/YYYY")} - ${moment(subcurso.dt_fim).format("DD/MM/YYYY")}`
                                : moment(subcurso.dt_inicio).format("DD/MM/YYYY")}
                        </span>
                        {subcurso.fechado ? (
                            <div className="tag-fechado">
                                Fechado (
                                {subcurso.dt_fechado && (
                                    <span style={{ fontSize: "12px" }}>{moment(subcurso.dt_fechado).format("DD/MM/YYYY")}</span>
                                )}
                                )
                            </div>
                        ) : (
                            ""
                        )}
                    </div>
                ),
                professores: subcurso.professores,
                inscritos: subcurso.inscritos,
                horas_trabalho: subcurso.horas_trabalho,
                aulasCriadas: subcurso.aulasCriadas,
                aulasDadas: subcurso.aulasDadas,
                opcoes: montarMenuDisciplina(subcurso, cursoIndex, curso),
                ativo: subcurso.ativo
            });
        });

        return _subcursos;
    };

    const listarSubCursosMobile = (subcursos, cursoIndex, curso) => {
        var _subcursos = [];

        subcursos.map(subcurso => {
            _subcursos.push({
                key: subcurso.id,
                id: subcurso.id,
                curso: (
                    <div className="nome-colaborador">
                        {!subcurso.agrupado ? (
                            <span className="titulo-curso">
                                {subcurso.codigo} - {subcurso.nome}
                            </span>
                        ) : (
                            <span className="titulo-curso">{subcurso.nome}</span>
                        )}
                        {subcurso.fechado && <span className="tag-fechado">Fechado</span>}
                    </div>
                ),
                nome: subcurso.nome,
                opcoes: (
                    <Dropdown
                        overlay={montarMenuDisciplinaMobile(subcurso, cursoIndex, curso)}
                        placement="bottomLeft"
                        onClick={event => event.stopPropagation()}
                        overlayStyle={{
                            zIndex: "9"
                        }}
                        trigger={["click"]}
                    >
                        <Link to="#" className="botao-icon-configs">
                            <i className="fas fa-cog" />
                        </Link>
                    </Dropdown>
                ),
                ativo: subcurso.ativo
            });
        });

        return _subcursos;
    };

    useEffect(() => {
        if (globalContext.acessos && organismo) carregarTurmas();
    }, [organismo, pesquisa, edicao, categoria, ativo, refreshKey, globalContext.acessos]);

    useEffect(() => {
        const opcoesFiltros = JSON.parse(localStorage.getItem("opcao_voltar"));
        if (opcoesFiltros?.organismo) {
            setOrganismo(opcoesFiltros.organismo);
        } else {
            if (globalContext.estabelecimento) setOrganismo(globalContext.estabelecimento?.id);
        }
    }, [globalContext.estabelecimento]);

    const turmaColumns =
        acessoM || acessoMultisseriado
            ? [
                  {
                      title: "Edição",
                      dataIndex: "edicao",
                      className: "td-50"
                  },
                  {
                      title: "Nível",
                      dataIndex: "categoria",
                      className: "td-155"
                  },
                  {
                      title: "Turma",
                      dataIndex: "nome",
                      className: "td-300"
                  },
                  {
                      title: "Coordenadores",
                      dataIndex: "coordenadores",
                      className: "td-300"
                  },
                  {
                      title: "Inscritos",
                      dataIndex: "inscritos",
                      className: "td-160"
                  },
                  {
                      title: "",
                      dataIndex: "opcoes",
                      className: "td-50"
                  }
              ]
            : [
                  {
                      title: "Edição",
                      dataIndex: "edicao",
                      className: "td-50"
                  },
                  {
                      title: "Nível",
                      dataIndex: "categoria",
                      className: "td-155"
                  },
                  {
                      title: "Turma",
                      dataIndex: "curso",
                      className: "td-300"
                  },
                  {
                      title: "Coordenadores",
                      dataIndex: "coordenadores",
                      className: "td-300"
                  },
                  {
                      title: "Inscritos",
                      dataIndex: "inscritos",
                      className: "td-160"
                  }
              ];

    const turmaColumnsMobile = [
        {
            title: "Turma",
            dataIndex: "curso",
            className: "td-265"
        },
        {
            title: "",
            dataIndex: "opcoes",
            className: "td-50"
        }
    ];

    if (redirect) return <Redirect to={redirectLink} />;

    return (
        <>
            <TabelaTurmas
                className="curso-disciplinas-desktop"
                loading={loading}
                pagination={pagination}
                acesso={acesso}
                columns={turmaColumns}
                dataSource={turmas}
                handleChangeTable={handleChangeTable}
                onRowClick={onRowClick}
                carregarSubRows={carregarDisciplinas}
                expandedRowRender={expandedRowRenderDesktop}
            />
            <TabelaTurmas
                className="curso-disciplinas-mobile"
                loading={loading}
                pagination={pagination}
                acesso={acesso}
                columns={turmaColumnsMobile}
                dataSource={turmas}
                handleChangeTable={handleChangeTable}
                onRowClick={onRowClick}
                carregarSubRows={carregarDisciplinasMobile}
                expandedRowRender={expandedRowRenderMobile}
            />
        </>
    );
};

export default Tabelas;
